import { searchHubNewsroom as hubNewsroomMapper } from '../helpers/filters/hub-newsroom';
import { search } from './search';

export const FILTER_HUB_NEWSROOM_KEY = 'hub-newsroom-filter';
export const searchHubNewsroom = search(hubNewsroomMapper);
